import { useState } from "react";
import { postSignup } from "./api";
import { PillButton } from "./ui";

export const SignupForm = ({ source, dark, label = "Put Me On The List", testid = "signup" }) => {
  const [first, setFirst] = useState("");
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) { setErr("Pop your email in first!"); return; }
    setLoading(true); setErr("");
    try {
      await postSignup({ first_name: first, email, source });
      setDone(true);
    } catch {
      setErr("Hmm, that didn't go through. Try again?");
    } finally {
      setLoading(false);
    }
  };

  if (done)
    return (
      <div data-testid={`${testid}-success`} className={`${dark ? "" : "result-card"} text-center py-4`}>
        <p className="sash-serif italic text-2xl" style={{ color: dark ? "var(--tan)" : "var(--tan-deep)" }}>
          You're on the list! ✨
        </p>
        <p className={`mt-2 ${dark ? "text-[var(--sand)]" : "text-[var(--ink-soft)]"}`}>
          We'll holler the second the doors reopen.
        </p>
      </div>
    );

  return (
    <div className="w-full max-w-[560px]" data-testid={`${testid}-form`}>
      <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
        <input
          className="sf-input sm:max-w-[150px]" placeholder="First name"
          value={first} onChange={(e) => setFirst(e.target.value)} data-testid={`${testid}-firstname`}
        />
        <input
          className="sf-input flex-1" type="email" placeholder="Email address"
          value={email} onChange={(e) => setEmail(e.target.value)} data-testid={`${testid}-email`}
        />
        <PillButton type="submit" variant={dark ? "light" : undefined} testid={`${testid}-submit`}>
          {loading ? "…" : label}
        </PillButton>
      </form>
      {err && <p className="mt-2 text-sm" style={{ color: dark ? "#ffd7c9" : "var(--clay)" }}>{err}</p>}
    </div>
  );
};
